import React from 'react';
import "./PanelListDefaultGridEditable.css";
import GridItemDefault from 'Components/PanelListDefault/GridItemDefault';
import { AutomaticallyListedAttributesGrid } from 'Components/AutomaticallyListedAttributesGrid/AutomaticallyListedAttributesGrid';
import NoDataFolder from "../../Components/SideBar/assets/icons/no-data-folder.png"

const PanelListDefaultGridEditable = ({
    rowsBackend,
    setRowsBackend,
    attributeList = { attributeList },
    updateHelperOperationList,
    height = '100%',
    localStorageName,
    isEmptyPanel = false,
    executeAfterSave,
    dsOperation
}) => {

    if (!rowsBackend) {
        return null;
    }

    const getRows = () => {
        return rowsBackend.map((row, index) => (
            <>
                <AutomaticallyListedAttributesGrid
                    row={row}
                    rowsBackend={rowsBackend}
                    setRowsBackend={setRowsBackend}
                    updateHelperOperationList={updateHelperOperationList}
                    localStorageName={localStorageName}
                    attributeList={attributeList}
                    executeAfterSave={executeAfterSave}
                    rowIndex={index}
                    dsOperation={dsOperation}
                />
            </>

        ));
    };

    let isEmpty = isEmptyPanel;
    if (!isEmpty && rowsBackend && rowsBackend.length === 1) {
        const constructorList = rowsBackend[0].constructorList;
        isEmpty = constructorList.every(item =>
            (item.argument === "" || item.argument === null)
        );
    }

    let panelEmpty
    if (isEmpty) {
        panelEmpty = (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                height: 'calc(100% - 37.6px)'
            }}>
                <img src={NoDataFolder} alt="Sem dados" style={{
                    width: '125px',
                    marginBottom: '20px'
                }} />
                <span style={{
                    fontSize: '1.2rem',
                    color: '#555'
                }}>Nenhum resultado encontrado.</span>
            </div>
        )
    }

    return (
        <div id='panel-list' style={{ height: height }}>
            <div className="scrollable-content">
                <div className="user-table">
                    <div className="user-row header">
                        <GridItemDefault.RenderGridItems
                            items={rowsBackend}
                            attributeList={attributeList}
                        />
                    </div>
                    {getRows()}
                </div>
                {panelEmpty ? panelEmpty : null}
            </div>
        </div>
    );
};

export default PanelListDefaultGridEditable;
